module.exports = __webpack_public_path__ + "static/media/gradient.7bec6aef.svg";